import { editorRegistry } from '@/components/userComponents/Text';
import { useEffect } from 'react';
import type { SlateEditorType } from '@builder4/shared/types/text';
import {
  ensureSlateSelectionObserver,
  removeSlateSelectionObserver,
} from '@/hooks/useSlateSelectionChange';
export const useEditorRegistry = (editor?: SlateEditorType, id?: string) => {
  useEffect(() => {
    if (!id || !editor) return;
    const handleWindowBlur = () => {
      editorRegistry.set(id, {
        editor,
        selection: editor.selection,
      });
    };

    window.addEventListener('mousedown', handleWindowBlur);
    window.addEventListener('blur', handleWindowBlur);

    editorRegistry.set(id, { editor, selection: editor.selection });
    ensureSlateSelectionObserver(id, editor);

    return () => {
      window.removeEventListener('mousedown', handleWindowBlur);
      window.removeEventListener('blur', handleWindowBlur);
      removeSlateSelectionObserver(id);
      editorRegistry.delete(id);
    };
  }, [editor, id]);
};
